<template>
  <div class="text-center">
    <div class="px-3 py-5">
      <i class="weui-icon-warn weui-icon_msg"/>
      <p class="pt-3">
        您的{{ os }}版本过低，我们建议您升级系统或者下载依康宝APP
      </p>
    </div>
    <div class="px-3">
      <a
        href="http://sj.qq.com/myapp/detail.htm?apkName=com.ant.health"
        class="weui-btn weui-btn_primary">下载依康宝APP</a>
    </div>
  </div>
</template>

<script>
import 'weui/src/style/base/reset.less';
import 'weui/src/style/widget/weui-button/weui-button.less';

export default {
  name: 'Download',
  computed: {
    os() {
      let os = '操作系统';
      if (/iOS|iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        os = 'iOS系统';
      }
      if (/Android/i.test(navigator.userAgent)) {
        os = '安卓系统';
      }
      return os;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/download/index.vue